import {
    Component,
    OnInit,
    OnDestroy,
    Input,
    ChangeDetectorRef
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription, Observable, of, EMPTY, firstValueFrom } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
import {
    API_BASE_PRODUCTSERVICE,
    API_MAP,
    API_BASE_FILESERVICE
} from 'src/environments/api';
import { ProductVariantService } from 'src/app/services/dataServices/product-variant-service/product-variant.service';
import { MalfunctionService } from 'src/app/services/malfunction-service/malfunction.service';
import { CertificationInterface } from 'src/app/model/certifications/certification-interface';
import { CertificationService } from 'src/app/services/dataServices/certification-service/certificationService';
import { CertificationVariantService } from 'src/app/services/dataServices/certification-variant-service/certification-variant-service';
import { CertificationVariantInterface } from 'src/app/model/certifications/certification-variant-interface';
import { UserService } from 'src/app/services/user-service/userservice';
import { ProductInterface } from 'src/app/model/products/product-interface';
import { ProductVariantInterface } from 'src/app/model/products/product-variant-interface';
import { HeaderServiceService } from 'src/app/services/header-service/header-service.service';
import { StripeService } from 'src/app/services/stripe-service/stripe.service';
import { Status } from 'src/app/model/enums/status';
import { ProductVariantVersionService } from 'src/app/services/dataServices/product-variant-version-service/product-variant-version.service';
import { VariantVersionInterface, VariantVersionUDto } from 'src/app/model/products/variant-version-interface';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MAX_VERSIONS_PER_VARIANT } from 'src/environments/constants';
import { IssuerCertificationCatalogueApiService } from 'src/app/construct-x/data-space/services/issuer-certification-catalogue-api.service';

@Component({
    selector: 'app-info-box',
    templateUrl: './info-box.component.html',
    styleUrls: ['./info-box.component.scss'],
    standalone: false
})
export class InfoBoxComponent implements OnInit, OnDestroy {
    @Input()
    product: ProductInterface;

    @Input()
    certification: CertificationInterface;

    @Input()
    variant: ProductVariantInterface;

    @Input()
    certificationVariant: CertificationVariantInterface;

    public activeOrg: any;

    public productPictureUrl: string;
    public productDescription: string;
    public productFeatures: string[];
    public variantDescription: string;

    public certificationPictureUrl: string;
    public certificationDescription: string;
    public certificationVariantDescription: string;

    private activeRouteSub: Subscription;
    private activeProductSub: Subscription;
    private activeCertificationSub: Subscription;
    private productId: string;

    showPictures: boolean = false;

    isPlattformAdmin: boolean;
    hasActiveProductVersion: boolean;
    public loading: boolean = false;
    isExpanded = false;
    Status = Status;
    displayedColumns: string[] = ['name', 'active', 'previous', 'actions'];
    readonly MAX_VERSIONS_PER_VARIANT = MAX_VERSIONS_PER_VARIANT;

    constructor(
        public productVariantService: ProductVariantService,
        private productVariantVersionService: ProductVariantVersionService,
        public router: Router,
        public productService: ProductService,
        public organisationService: OrganisationService,
        public variantService: ProductVariantService,
        private malfunctionService: MalfunctionService,
        private activeRoute: ActivatedRoute,
        private cd: ChangeDetectorRef,
        private dialogService: DialogService,
        public certificationService: CertificationService,
        public certificationVariantService: CertificationVariantService,
        private userService: UserService,
        public headerService: HeaderServiceService,
        private stripeService: StripeService,
        private cdr: ChangeDetectorRef,
        public versionService: ProductVariantVersionService,
        protected http: HttpClient,
        private issuerCatalogueApi: IssuerCertificationCatalogueApiService,
    ) { }

    toggle(): void {
        this.isExpanded = !this.isExpanded;
    }

    toggleVersionActive(version: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        this.dialogService
            .openConfirmDialog(
                'Wollen Sie den Versions-Status wirklich ändern?',
                'Abbrechen',
                'Ändern'
            )
            .subscribe(async (confirmed) => {
                if (confirmed) {
                    const updated: VariantVersionUDto = {
                        comment: version.comment,
                        description: version.description,
                        id: version.id,
                        keywords: version.keywords,
                        name: version.name,
                        previousVersion: version.previousVersion,
                        productVariantId: version.productVariantId,
                        ptgVersionIds: version.ptgVersionIds ?? [],
                        status: version.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE',
                      };

                    let versionURL = '/proxy/api/v0/productservice/versions/' + version.id
                    await new Promise((resolve, reject) => {
                      this.http.put<any>(versionURL, updated, httpOptions).subscribe(
                        (productDTO) => {

                            this.variant.variantVersions.forEach((v) => {
                                if (v.id == productDTO.id){
                                    v.status = productDTO.status;
                                }
                                this.cd.detectChanges();
                            });
                        },
                        () => {
                          reject(false);
                        }
                      );
                    });
                }
            });
    }


    onEditVariantVersion(versionId: number, productId: string, variantId: string): void {
        this.versionService.ITEM_MAP[':versionId'] = String(versionId);
        this.router.navigate([
            '/organisations/' +
            this.organisationService.activeItem.organisationId +
            '/products/' +
            productId +
            '/variants/' +
            variantId +
            '/version/' +
            versionId +
            '/edit'
        ]);
    }

    onChangeVariantVersion(versionId: number, productId: string, variantId: string) {

    }

    async onDeleteVariantVersion(versionId: number, productId: string, variantId: string) {
        await this.versionService.setActiveVersion(versionId);
        this.dialogService
            .openConfirmDialog(
                'Wollen Sie die Version wirklich löschen?',
                'Abbrechen',
                'Löschen'
            )
            .subscribe((confirmed) => {
                if (confirmed) {
                    this.versionService
                        .deleteItem(this.versionService.activeItem)
                        .then(
                            async () => {
                                // TODO: Quickfix for now
                                this.variant.variantVersions = this.variant.variantVersions
                                    .filter(v => v.id !== versionId);

                                this.cd.detectChanges();
                                this.dialogService.openDialog(
                                    'Version gelöscht',
                                    'Die Version wurde erfolgreich gelöscht.'
                                );
                                this.cd.detectChanges();
                            },
                            () => {
                                this.dialogService.openDialog(
                                    'Version nicht gelöscht',
                                    'Die letzte Version einer Produktvariante darf nicht gelöscht werden.'
                                );
                            }
                        )
                        .catch((e) => {
                        });
                }
            });
    }

    editProduct(): void {
        this.router.navigate([
            '/organisations/' +
            this.organisationService.activeOrganisation.organisationId +
            '/products/' +
            this.productService.activeProduct.id +
            '/edit'
        ]);
    }

    onAddVariantVersion(versionId: number, productId: string, variantId: string): void {
        this.versionService.ITEM_MAP[':versionId'] = String(versionId);
        this.router.navigate([
            '/organisations/' +
            this.organisationService.activeItem.organisationId +
            '/products/' +
            productId +
            '/variants/' +
            variantId +
            '/version/' +
            versionId +
            '/create'
        ]);
    }

    onVariantAdd(productId: string, variantId: string): void {
        this.router.navigate([
            '/organisations/' +
            this.organisationService.activeItem.organisationId +
            '/products/' +
            productId +
            '/variants/create'
        ]);
    }

    onVariantEdit(productId: string, variantId: string): void {
        this.router.navigate([
            '/organisations/' +
            this.organisationService.activeItem.organisationId +
            '/products/' +
            productId +
            '/variants/' +
            variantId +
            '/edit'
        ]);
    }

    licenseProduct(): void {
        this.router.navigate([
            '/organisations/' +
            this.organisationService.activeOrganisation.organisationId +
            '/products/' +
            this.productService.activeProduct.id +
            '/lizenz'
        ]);
    }

    editCertification(): void {
        this.router.navigate([
            '/organisations/' +
            this.organisationService.activeOrganisation.organisationId +
            '/certifications/' +
            this.certificationService.activeCertification.id +
            '/edit'
        ]);
    }

    deleteProduct(): void {
        this.dialogService
            .openConfirmDialog(
                'Wollen Sie das Produkt wirklich löschen?',
                'Abbrechen',
                'Löschen'
            )
            .subscribe(
                (result) => {
                    if (result) {
                        this.loading = true;
                        this.processProductDeletion();
                    }
                },
                (e) => { }
            );
    }

    deleteCertification(): void {
        this.dialogService
            .openConfirmDialog(
                'Wollen Sie die Zertifizierung wirklich löschen?',
                'Abbrechen',
                'Löschen'
            )
            .subscribe(
                (result) => {
                    if (result) {
                        if (this.certificationService.activeItem.issuerManaged) {
                            void this.deleteIssuerCertification();
                            return;
                        }
                        this.certificationService
                            .deleteCertification(
                                this.certificationService.activeItem
                            )
                            .then(() => {
                                this.router.navigate([
                                    'organisations/' +
                                    this.organisationService
                                        .activeOrganisation.organisationId +
                                    '/certifications'
                                ]);
                            });
                    }
                },
                (e) => {
                    // this.dialogService.openDialog(e.errorTitle, e.errorText);
                }
            );
    }

    private async deleteIssuerCertification(): Promise<void> {
        const certification = this.certificationService.activeItem;
        const participantContextId = certification.issuerParticipantContextId;
        const credentialDefinitionId =
            certification.issuerCredentialDefinitionId;
        if (!participantContextId || !credentialDefinitionId) {
            return;
        }
        try {
            await firstValueFrom(
                this.issuerCatalogueApi.deleteCredentialDefinition(
                    participantContextId,
                    credentialDefinitionId,
                    this.organisationService.activeItem.organisationId
                )
            );
            this.certificationService.deleteVariantsIn(certification);
            this.certificationService.nextCollection();
            await this.router.navigate([
                'organisations/' +
                    this.organisationService.activeOrganisation.organisationId +
                    '/certifications'
            ]);
            this.dialogService.openDialog(
                'Zertifizierung gelöscht',
                'Die Credential Definition wurde aus Issuer Service und Wallet gelöscht.'
            );
        } catch (error: any) {
            this.dialogService.openDialog(
                'Zertifizierung nicht gelöscht',
                error?.error?.message ??
                    error?.error?.error ??
                    error?.message ??
                    'Die Credential Definition konnte nicht gelöscht werden.'
            );
        }
    }

    registerSsoClient(): void {
        this.router.navigate([
            '/organisations/' +
            this.organisationService.activeOrganisation.organisationId +
            '/products/' +
            this.productService.activeProduct.id +
            '/sso'
        ]);
    }

    showMalfunctionManagement(): void {
        this.router.navigate([
            '/organisations/' +
            this.organisationService.activeOrganisation.organisationId +
            '/products/' +
            this.productService.activeProduct.id +
            '/malfunctionManagement'
        ]);
    }

    ngOnInit(): void {
        this.isPlattformAdmin =
            this.userService.isUserAdminOfOrganisationOrPlattformAdmin(
                this.organisationService.activeItem.organisationId
            );
        this.activeOrg = this.headerService.activeOrganisation.organisationId;
        this.productId = this.productService.activeProduct?.id ? String(this.productService.activeProduct.id) : '';

        if (this.certification) {
            this.activeCertificationSub =
                this.certificationService.activeItemObserver.subscribe(
                    (certification) => {
                        this.showPictures = false;

                        if (certification) {
                            this.certification = certification;
                            this.certificationDescription =
                                this.certification.description;

                            if (certification.pictureId) {
                                this.certificationPictureUrl =
                                    this.certificationService.getCertificationPicture(
                                        certification.id
                                    );
                            } else {
                                this.certificationPictureUrl =
                                    environment.defaultPictureProducts;
                            }

                            if (
                                this.certification.galleryPictureIds.length > 0
                            ) {
                                if (this.certification.galleryPictureIds) {
                                    for (let pictureId of this.certification
                                        .galleryPictureIds) {
                                        var url =
                                            API_BASE_FILESERVICE +
                                            '/file/' +
                                            pictureId;
                                    }
                                }
                            }
                        }
                    }
                );
        }

        this.activeProductSub =
            this.productService.activeItemObserver.subscribe((product) => {
                this.showPictures = false;
                if (product && product.pictureId) {
                    this.productPictureUrl =
                        this.productService.getProductPicture(product.id);
                } else {
                    this.productPictureUrl = environment.defaultPictureProducts;
                }

                if (this.product) {
                    this.activeProductSub =
                        this.productService.activeItemObserver.subscribe(
                            (product) => {
                                this.showPictures = false;
                                if (product) {
                                    // this.product = product;
                                    // this.productDescription =
                                    //     this.product.description;
                                    // this.productFeatures =
                                    //     this.product.features;
                                    // this.hasActiveProductVersion =
                                    //     this.productService.checkIfProductHasActiveVersion(
                                    //         this.product
                                    //     );

                                    // if (product.pictureId) {
                                    //     this.productPictureUrl =
                                    //         this.productService.getProductPicture(
                                    //             product.id
                                    //         );
                                    // } else {
                                    //     this.productPictureUrl =
                                    //         environment.defaultPictureProducts;
                                    // }

                                    // if (
                                    //     this.product.galleryFileIds.length > 0
                                    // ) {
                                    //     if (this.product.galleryFileIds) {
                                    //         for (let pictureId of this.product
                                    //             .galleryFileIds) {
                                    //             var url =
                                    //                 API_BASE_FILESERVICE +
                                    //                 '/file/' +
                                    //                 pictureId;
                                    //         }
                                    //     }
                                    // }
                                }
                            }
                        );
                }
                if (!this.cd['destroyed']) {
                    this.cd.detectChanges();
                }
            });
    }

    ngOnDestroy() {
        if (this.activeRouteSub) {
            this.activeRouteSub.unsubscribe();
        }
        if (this.activeProductSub) {
            this.activeProductSub.unsubscribe();
        }
        if (this.activeCertificationSub) {
            this.activeCertificationSub.unsubscribe();
        }
    }

    private deleteProductNormally(): void {
        this.productService
            .deleteProduct(this.productService.activeItem)
            .then(() => {
                this.loading = false;
                this.cdr.detectChanges();
                this.navigateAfterDeletion();
            })
            .catch((error) => {
                this.loading = false;
                this.cdr.detectChanges();
                console.error('Error deleting product:', error);
                this.dialogService.openDialog(
                    'Fehler beim Löschen des Produkts',
                    'Das Produkt konnte nicht gelöscht werden.'
                );
            });
    }

    private navigateAfterDeletion(): void {
        this.router.navigate([
            'organisations/' +
            this.organisationService.activeOrganisation.organisationId +
            '/products'
        ]);

        this.dialogService.openDialog(
            'Das Produkt wurde erfolgreich gelöscht',
            ''
        );
    }

    private processProductDeletion(): void {
        this.stripeService.getAllListingProductFromOrgId(this.activeOrg)
            .pipe(
                catchError(() => {
                    this.deleteProductNormally();
                    return EMPTY;
                }),
                switchMap((data: any[]) => {
                    const matchingListing = data.find(item =>
                        item.originListing?.products?.some(id => String(id) === this.productId)
                    );

                    if (!matchingListing) {
                        this.deleteProductNormally();
                        return EMPTY;
                    }

                    return this.removeFromOriginListing(matchingListing);
                })
            )
            .subscribe();
    }

    private removeFromOriginListing(matchingListing: any) {
        const subscriptionId = matchingListing.originListing.subscriptionId;

        return this.stripeService.removeProductFromListing(
            this.activeOrg,
            subscriptionId,
            this.productId
        ).pipe(
            switchMap((removeResponse) => {
                if (removeResponse.status >= 400) {
                    this.loading = false;
                    this.dialogService.openDialog(
                        'Fehler beim Entfernen des Produkts aus dem Abonnement',
                        ''
                    );
                    return EMPTY;
                }

                return this.handlePrioListingIfNeeded(matchingListing);
            }),
            catchError(() => {
                this.loading = false;
                this.dialogService.openDialog('Fehler beim Entfernen des Produkts', '');
                return EMPTY;
            })
        );
    }

    private handlePrioListingIfNeeded(matchingListing: any) {
        const productId = String(this.productId);
        const isInPrioListing = matchingListing.prioListing?.products?.some(id => String(id) === productId);

        if (isInPrioListing) {
            return this.stripeService.prioritizeProduct(
                this.activeOrg,
                matchingListing.originListing.subscriptionId,
                this.productId,
                false
            ).pipe(
                tap(() => this.deleteProductNormally()),
                catchError(() => {
                    this.deleteProductNormally();
                    return EMPTY;
                })
            );
        } else {
            this.deleteProductNormally();
            return EMPTY;
        }
    }

    deleteVariant(productId: string, variantId: string) {
        this.dialogService
            .openConfirmDialog(
                'Wollen Sie die Variante wirklich löschen?',
                'Abbrechen',
                'Löschen'
            )
            .subscribe((confirmed) => {
                if (confirmed) {
                    this.productVariantService.ITEM_MAP[':organisationId'] =
                        String(this.organisationService.activeItem.organisationId);
                    this.productVariantService.ITEM_MAP[':productId'] = String(
                        this.product.id
                    );

                    this.productVariantService.ITEM_MAP[':variantId'] = String(
                        this.variant.id
                    );
                    this.productVariantService
                        .deleteItem(this.variant)
                        .then(
                            async () => {
                                // On success, route to product overview and reload organisationProducts
                                await this.productService.loadProductsForOrganisation(
                                    this.organisationService.activeItem
                                );
                                let url: string =
                                    '/organisations/' +
                                    this.productVariantService.ITEM_MAP[
                                    ':organisationId'
                                    ] +
                                    '/products/' +
                                    this.productVariantService.ITEM_MAP[
                                    ':productId'
                                    ];
                                this.router.navigateByUrl(url);
                                // TODO: Quickfix for now, check later why router navigation does not work
                                this.product.productVariants = this.product.productVariants
                                    .filter(v => String(v.id) !== String(variantId));
            
                                this.cd.detectChanges();
                                this.dialogService.openDialog(
                                    'Variante gelöscht',
                                    'Die Variante wurde erfolgreich gelöscht.'
                                );
                            },
                            () => {
                                // On error, alert user
                                this.dialogService.openDialog(
                                    'Variante nicht gelöscht',
                                    'Die letzte Variante eines Produktes darf nicht gelöscht werden.'
                                );
                            }
                        )
                        .catch((e) => {
                        });
                }
            });
    }

    private prevNames = new Map<number, string>();
    private loadingIds = new Set<number>();

    loadPrevVersionName(prevVersionId: number): void {
      if (!prevVersionId || this.prevNames.has(prevVersionId) || this.loadingIds.has(prevVersionId)) {
        return;
      }
      this.loadingIds.add(prevVersionId);
      const versionURL = '/proxy/api/v0/productservice/versions/' + prevVersionId;
      this.http.get<any>(versionURL).subscribe({
        next: (productDTO) => {
          const name = productDTO?.name ?? '';
          this.prevNames.set(prevVersionId, name);
          this.loadingIds.delete(prevVersionId);
          this.cd.detectChanges();
        },
        error: () => {
          this.prevNames.set(prevVersionId, '');
          this.loadingIds.delete(prevVersionId);
        }
      });
    }

    getPrevVersion(v: VariantVersionInterface): string {
        const prevVersionId = v.previousVersion;
        if (!prevVersionId) {
            return '';
        }

        // TODO: Quickfix - in case prevVersionId was deleted, but not in  v.previousVersion (Backend TODO)
        const existsLocally = this.variant.variantVersions.some(ver => ver.id === prevVersionId);
        if (!existsLocally) return ''; 

        if (!this.prevNames.has(prevVersionId)) {
            this.loadPrevVersionName(prevVersionId);
            return '';
        }
        return this.prevNames.get(prevVersionId) ?? '';
    }

    onVariantCardClick(product: ProductInterface, variant: ProductVariantInterface): void {
        this.productService.setActiveItem(product.id);
        this.productVariantService.ITEM_MAP[':productId'] = String(product.id);
        this.productVariantService.setActiveVariant(variant.id);
        
        // this.router.navigate([
        //     'organisations',
        //     this.organisationService.activeItem.organisationId,
        //     'products',
        //     product.id,
        //     'variants',
        //     variant.id
        // ]);
    }

    hasReachedVersionLimit(variant: ProductVariantInterface): boolean {
        return (variant?.variantVersions?.length ?? 0) >= MAX_VERSIONS_PER_VARIANT;
    }
}
